import { Modal } from './ModalHost';
import {
  ApiError,
  getActiveAssignmentBlockers,
} from '@/types/errors';
import { formatCalendarDate } from '@/utils/format';

interface Props {
  error: ApiError;
  onClose: () => void;
}

export function ArchiveBlockersModal({ error, onClose }: Props) {
  const blockers = getActiveAssignmentBlockers(error);
  return (
    <Modal
      open={true}
      onClose={onClose}
      title="Archive blocked: active assignments exist"
      role="alertdialog"
      scrimDismissDisabled
    >
      <p>
        End-date the active assignments below before archiving. Per spec §3,
        only Admin can edit Assignment.End Date on a Completed agreement.
      </p>
      <ul style={{ paddingLeft: 16 }}>
        {blockers.map((b) => (
          <li key={b.assignment_id}>
            Assignment {b.assignment_id} — start {formatCalendarDate(b.start_date)},
            end {formatCalendarDate(b.end_date)}
          </li>
        ))}
      </ul>
      <div className="form-actions">
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  );
}
